module.exports = __webpack_public_path__ + "assets/images/digital_license_bg_img.7c2c668f.jpg";